export default "__VITE_ASSET__CpG9rj0P__"